import { useState } from 'react'

export const useDisclosureWithAnchor = <T>() => {
  const [anchorEl, setAnchorEl] = useState<T | null>(null)
  const isOpen = Boolean(anchorEl)

  function open(event: React.MouseEvent<T>) {
    setAnchorEl(event.currentTarget)
  }

  function close() {
    setAnchorEl(null)
  }

  return {
    anchorEl,
    open,
    close,
    isOpen,
  }
}
